function ErrorBoundary({ children }: React.PropsWithChildren) {
    return <>
        {children}
    </>
}

export default ErrorBoundary